import { searchCategories, searchFilters } from "@/mocks/comicGuide";

export default function SearchGuide() {
  return (
    <section id="search" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-700">
              <i className="ri-grid-fill"></i> 分类检索
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">海量作品，一搜即达</h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              漫画软件应用的分类检索能力，决定你能否快速找到想看的作品。从官方分类到标签筛选，多维度组合让找漫又快又准。
            </p>

            <div className="mt-6">
              <h3 className="text-sm font-bold text-foreground-800">热门分类</h3>
              <div className="mt-3 flex flex-wrap gap-2">
                {searchCategories.map((c) => (
                  <span
                    key={c}
                    className="cursor-pointer whitespace-nowrap rounded-full bg-secondary-100 px-4 py-1.5 text-sm text-secondary-900 transition hover:bg-secondary-500 hover:text-background-50"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {searchFilters.map((f) => (
              <div key={f.title} className="rounded-2xl border border-background-200 bg-background-100 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                  <i className={`${f.icon} text-lg`}></i>
                </span>
                <h3 className="mt-3 text-base font-bold text-foreground-950">{f.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}